export const SET_HRES92U_INDEX_DISP = 'SET_HRES92U_INDEX_DISP'
export const GET_HRES92U_INDEX_DISP = 'GET_HRES92U_INDEX_DISP'
export const SET_HRES92U_DETAIL_DISP = 'SET_HRES92U_DETAIL_DISP'
export const GET_HRES92U_DETAIL_DISP = 'GET_HRES92U_DETAIL_DISP'
export const SET_HRES92U_COLUMNS = 'SET_HRES92U_COLUMNS'
export const GET_HRES92U_COLUMNS = 'GET_HRES92U_COLUMNS'
export const SET_HRES92U_LABELS = 'SET_HRES92U_LABELS'
export const GET_HRES92U_LABELS = 'GET_HRES92U_LABELS'
export const RECEIVED_HRES92U_COLUMNS_LABELS = 'RECEIVED_HRES92U_COLUMNS_LABELS'
export const SET_HRES92U_INDEX = 'SET_HRES92U_INDEX'
export const GET_HRES92U_INDEX = 'GET_HRES92U_INDEX'
export const RECEIVED_HRES92U_INDEX = 'RECEIVED_HRES92U_INDEX'
export const SET_HRES92U_INDEX_SELECTED = 'SET_HRES92U_INDEX_SELECTED'
export const GET_HRES92U_INDEX_SELECTED = 'GET_HRES92U_INDEX_SELECTED'
export const SET_HRES92U_DETAIL = 'SET_HRES92U_DETAIL'
export const GET_HRES92U_DETAIL = 'GET_HRES92U_DETAIL'
export const RECEIVED_HRES92U_DETAIL = 'RECEIVED_HRES92U_DETAIL'
export const TOGGLE_HRES92U_PAGE = 'TOGGLE_HRES92U_PAGE'
export const POST_HRES92U_SEND_APPROVE = 'POST_HRES92U_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres92u/mutation-types.js